import * as React from 'react';
import clsx from 'clsx';
import { Grid2 } from '../../Mui/Grid2';
import { IconError } from '../../internal/icons';
import { formItemClasses } from './style';
import { ErrorList } from '../../Form';
export const FormItemNoContextController = (props) => {
    const { wrapperCol, children, errors, extra, fieldId, maxExceededIndicator, countMessage, showCountPosition = 'bottom-start', renderSortErrorsAndExtra, } = props;
    const mergedWrapperCol = wrapperCol ?? {};
    const className = clsx(`${formItemClasses.control.root}`, mergedWrapperCol.className);
    const inputNode = (React.createElement("div", { className: `${formItemClasses.control.input}`, key: "input" },
        React.createElement("div", { className: `${formItemClasses.control.content}` }, children)));
    const errorListNode = errors.length ? (React.createElement("div", { className: `${formItemClasses.item.explainError}-container`, key: "errorList" },
        React.createElement(IconError, { className: `${formItemClasses.item.explainError}-icon` }),
        React.createElement(ErrorList, { errors: errors, className: `${formItemClasses.item.explain}-connected`, fieldId: fieldId }))) : null;
    const maxExceededIndicatorNode = maxExceededIndicator ? (React.createElement("div", { key: "maxExceededIndicatorNode", className: clsx(`${formItemClasses.item.explainError}-container`, `${formItemClasses.item.maxExceededIndicator}`, showCountPosition === 'bottom-end' &&
            `${formItemClasses.item.maxExceededIndicatorEnd}`) },
        React.createElement(ErrorList, { errors: [maxExceededIndicator], className: `${formItemClasses.item.explain}-connected`, fieldId: `${fieldId}_max_exceeded_indicator` }))) : null;
    const extraProps = {};
    if (fieldId) {
        extraProps.id = `${fieldId}_extra`;
    }
    const extraNode = extra ? (React.createElement("div", { ...extraProps, key: "extra", className: clsx(formItemClasses.item.extra, {
            [`${formItemClasses.item.extraWithExplain}`]: !!errorListNode,
        }) }, extra)) : null;
    const sortErrorsAndExtraNode = typeof renderSortErrorsAndExtra === 'function' ? (renderSortErrorsAndExtra?.(errorListNode, maxExceededIndicatorNode, extraNode)) : (React.createElement(React.Fragment, null,
        errorListNode,
        maxExceededIndicatorNode,
        extraNode));
    const countMessageNode = countMessage ? (React.createElement("div", { key: "countMessage", id: `${fieldId}_count_message`, className: clsx(`${formItemClasses.item.countMessage}`, showCountPosition === 'bottom-end' &&
            `${formItemClasses.item.countMessageEnd}`) }, countMessage)) : null;
    return (React.createElement(Grid2, { ...mergedWrapperCol, className: className },
        inputNode,
        countMessageNode,
        sortErrorsAndExtraNode));
};
